module.exports = __webpack_public_path__ + "img/normal_icon_05.ee71404.png";